import React from "react";
import { useTranslation } from "react-i18next";
import { Routes } from "../../Routes";
import SectionTitleRow from "./SectionTitleRow";
import { sidebarIcons } from "./sidebarIcons";

type MenuContentEmployeesOverviewProps = {
  compact?: boolean;
  onClick: (event: React.MouseEvent) => void;
};

export function MenuContentEmployeesOverview({
  compact = false,
  onClick,
}: MenuContentEmployeesOverviewProps) {
  const { t } = useTranslation();

  return (
    <SectionTitleRow
      title={t("menu.admin")}
      icon={sidebarIcons.admin}
      selected={window.location.pathname === Routes.Admin}
      link={Routes.Admin}
      compact={compact}
      onClick={onClick}
    />
  );
}
